import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import '../estilo.css';

const indicatorImages = [
  require('../img/Indicador_Agressao.png'),
  require('../img/Indicador_Volume.png'),
  require('../img/Media_ATR.png'),
  require('../img/Quantum_PTL.png'),
  require('../img/Indicador_Bars.png'),
];

export default function Indicadores() {
  const { t } = useTranslation();
  const featureItems = t('indicators.features', { returnObjects: true });
  const supportedIndicators = t('indicators.supported', { returnObjects: true });
  const cardTranslations = t('indicators.cards', { returnObjects: true });
  const indicatorCards = indicatorImages.map((image, index) => ({
    image,
    ...(Array.isArray(cardTranslations) ? cardTranslations[index] : {}),
  }));

  return (
    <section id="indicadores" className="container-fluid indicadores-section">
      <div className="public-section-inner">
        <div className="indicators-hero">
          <div>
            <span className="section-eyebrow">Quantum Trades EA</span>
            <h1>{t('indicators.title')}</h1>
            <p className="description">{t('indicators.intro')}</p>
          </div>
          <img
            className="indicators-main-image"
            src={require('../img/QuantumEA.png')}
            alt="Quantum Trades EA"
          />
        </div>

        <div className="indicator-feature-panel">
          <h2>{t('indicators.resources')}</h2>
          <ul className="indicator-feature-list">
            {Array.isArray(featureItems) && featureItems.map((item) => (
              <li key={item}>{item}</li>
            ))}
          </ul>
        </div>

        <header className="public-section-heading">
          <span className="section-eyebrow">{t('indicators.showcaseEyebrow')}</span>
          <h2>{t('indicators.showcaseTitle')}</h2>
          <p>{t('indicators.showcaseText')}</p>
        </header>

        <div className="indicator-grid">
          {indicatorCards.map((indicator) => (
            <article className="indicator-card" key={indicator.title}>
              <img src={indicator.image} alt={indicator.alt} loading="lazy" />
              <div>
                <h3>{indicator.title}</h3>
                <p>{indicator.description}</p>
              </div>
            </article>
          ))}
        </div>

        <div className="supported-indicators">
          <h2>{t('indicators.supportedTitle')}</h2>
          <div className="supported-indicators-grid">
            {Array.isArray(supportedIndicators) && supportedIndicators.map((indicator) => (
              <span key={indicator}>{indicator}</span>
            ))}
          </div>
        </div>

        <div className="indicators-cta">
          <div>
            <span className="section-eyebrow">{t('indicators.next')}</span>
            <h2>{t('indicators.ctaTitle')}</h2>
            <p>{t('indicators.ctaText')}</p>
          </div>
          <Link reloadDocument to="/cadastro" className="btn btn-primary btn-lg">
            {t('indicators.cta')}
          </Link>
        </div>
      </div>
    </section>
  );
}
